import React from 'react';
import * as componentStyle from './headingComponent.module.scss';
import { Heading } from '../../interface/header.interface';

interface HeadingProps {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div';
  data: Heading[] | null;
  textAlign?: 'left' | 'center' | 'right';
  textTransform?: 'none' | 'capitalize' | 'uppercase' | 'lowercase';
  className?: string;
}

export default function HeadingComponent({ 
  as: Tag = 'h2',
  data, 
  textAlign = 'left',
  textTransform = 'none',
  className
}: HeadingProps) {
  return (
    <>
      {data && (
        <Tag className={`${componentStyle.headingComponent} ${className && className}`} style={{ textAlign: `${textAlign}`, textTransform: `${textTransform}`}}>
          {data?.map((context: Heading, index: number) => (
            <span key={`item${index}`} className={componentStyle.headingComponent__child}>{context.headingChild || 'N/A'}</span>
          ))}
        </Tag>
      )}
    </>
  )
}
